import { call, put, select, takeEvery } from 'redux-saga/effects';
import {
  GegeCheckoutProduktPayload,
  getSelectedZusatzoptionen,
  GlobalActions,
  GlobalPut,
  ShopTarifierungRequestEvents,
} from '@ps20-frontend/shop-integration-redux';
import { DATEFORMAT_LOCAL_STATE, getVersicherteGegeText } from '@ps20-frontend/utils';
import { App, GEGE_TITLE, Produktlinie } from '@ps20-frontend/frontend-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { getSelectedProduktlinie } from '@ps20-frontend/preis-lib';
import dayjs from 'dayjs';
import { delay } from 'rxjs';
import { GegenstandCategory } from '@ps20/bff-models';
import { IAppState } from '../appState';
import { GegeActions } from '../gegeActions';

export function* watchInDashboardUebernehmenSaga() {
  yield takeEvery(GegeActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateDashboardData, App.GEGE));
  yield takeEvery(GegeActions.ABSPRUNG_INS_DASHBOARD, safeSaga(generateProduktData, App.GEGE));
  yield takeEvery(
    ShopTarifierungRequestEvents.PREISE_SHOP_REQUESTED_SUCCESSFUL_GEGE,
    safeSaga(generateDelayedProduktData, App.GEGE),
  );
}

export function* generateDelayedProduktData() {
  yield delay(100);
  yield* generateProduktData();
}

export function* generateProduktData() {
  const globalPut = GlobalPut.getInstance();
  const state: IAppState = yield select();

  const hasFahrrad = state.gegenstandsschutz.items.some(
    item => item.category?.id === GegenstandCategory.FAHRRAD,
  );

  const produktActionData: GegeCheckoutProduktPayload = {
    appId: App.GEGE,
    angebotsId: state.angebotsId,
    uebersichtTitle: GEGE_TITLE,
    laufzeit: state.vertragsoptionen.vertragslaufzeit,
    versichertesRisiko: getVersichertesRisiko(state),
    beginndatum: state.vertragsoptionen.beginnDatum,
    vorvertragsnummer: state.vertragsoptionen.vorvertragsNummern,
    gegenstaende: state.gegenstandsschutz.items.map(gegenstand => {
      return {
        id: gegenstand.id,
        kategorie: {
          id: (GegenstandCategory as Record<string, GegenstandCategory>)[gegenstand.category?.id],
          name: gegenstand.category?.name,
        },
        versicherungssumme: gegenstand.insuranceValue,
        kaufdatum: dayjs(gegenstand.purchaseDate).format(DATEFORMAT_LOCAL_STATE),
        beitrag: gegenstand.bruttoPrice,
        modell: gegenstand.model,
        informationen: gegenstand.information,
        anzahlVorschaeden: gegenstand.anzahlVorschaeden,
      };
    }),
    fahrradVorschaeden: hasFahrrad ? state.fahrradVorschaeden : undefined,
  };
  yield call([globalPut, globalPut.put], new GlobalActions().produktAction(produktActionData));
}

export function* generateDashboardData() {
  const state: IAppState = yield select();
  const globalPut = GlobalPut.getInstance();
  const selectedProduktlinie: Produktlinie = getSelectedProduktlinie(state.produkt);

  yield put(new GegeActions().vorschlagdatenChanged(state.angebotsId));

  yield call(
    globalPut.put.bind(globalPut),

    new GlobalActions().inDashboardUebernehmen({
      appId: App.GEGE,
      angebotsId: state.angebotsId,
      kurztext: selectedProduktlinie.kurztext,
      ausgewaehlteLinie: selectedProduktlinie.produktName,
      vertragslaufzeit: state.vertragsoptionen.vertragslaufzeit,
      versichertesRisiko: getVersichertesRisiko(state),
      selectZusatzoptionen: getSelectedZusatzoptionen(selectedProduktlinie.zusatzoptionen),
      beginn: state.vertragsoptionen.beginnDatum,
    }),
  );
}

export const getVersichertesRisiko = (state: IAppState) => {
  const mappedGegenstaende = state.gegenstandsschutz.items.map(item => {
    return item.category?.name;
  });
  return getVersicherteGegeText(mappedGegenstaende);
};
